import type { ICRMEventsContext } from '@fhs-legacy/frontend/src/state/crm-events';

import type { PipelineStepContext, PipelineStepResult } from '..';

import { Logger } from './Logger';

export interface IPipelineBaseStep {
  //  Step name for logging and debugging
  readonly name: string;
  execute(context: PipelineStepContext): Promise<PipelineStepResult>;
  setCRMLogger?(logger: ICRMEventsContext['logRBIEvent']): void;
}

// Common functionality for all steps
export abstract class PipelineBaseStep implements IPipelineBaseStep {
  abstract readonly name: string;
  private _logger?: Logger;

  protected get logger(): Logger {
    if (!this._logger) {
      this._logger = new Logger(this.name);
    }
    return this._logger;
  }

  setCRMLogger(logger: ICRMEventsContext['logRBIEvent']): void {
    this.logger.setCRMLogger(logger);
  }

  abstract execute(context: PipelineStepContext): Promise<PipelineStepResult>;

  protected success(data?: Partial<PipelineStepContext>): PipelineStepResult {
    return {
      success: true,
      data,
    };
  }

  protected error(
    code: string,
    message: string,
    userMessage?: string,
    retryFromStep?: string
  ): PipelineStepResult {
    return {
      success: false,
      shouldStop: true,
      error: {
        code,
        message,
        userMessage,
        retryFromStep,
        preserveContext: true,
      },
    };
  }
  // TODO: may or may not be needed
  protected warning(code: string, message: string, userMessage?: string): PipelineStepResult {
    this.logger.logCRMEvent('StepWarning', {
      stepName: this.name,
      warningCode: code,
      warningMessage: message,
      success: true,
    });

    // TODO: data?: Partial<PipelineStepContext>
    return {
      success: true,
      shouldStop: false,
      error: {
        code,
        message,
        userMessage,
      },
    };
  }
}
